import { render, staticRenderFns } from "./PostLogin.vue?vue&type=template&id=f04d08f6&scoped=true"
import script from "./PostLogin.vue?vue&type=script&lang=js"
export * from "./PostLogin.vue?vue&type=script&lang=js"
import style0 from "./PostLogin.vue?vue&type=style&index=0&id=f04d08f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04d08f6",
  null
  
)

export default component.exports